import moment from "moment";
import { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner } from "reactstrap";
import pkn1 from "../../../assets/imagepkn.png";
import pkn2 from "../../../assets/imagepkn2.png";

export const ButtonPrintStikerPlatKPR = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-item"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

export const PrintDocStikerPlatKPR = ({ innerRef, item, companyName, companyValue }) => {
  const handleValidDate = (date) => {
    return moment(date).format("MMM D, YYYY");
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  return item === undefined || item === null ? (
    <></>
  ) : (
    <div
      className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
        <div
          style={{
            textAlign: "center",
            fontSize: "18px",
            fontWeight: "bold",
          }}
        >
          STIKER/PLAT KPR BERSUBSIDI BTN
          <br />
          YANG DILENGKAPI DENGAN PENANDA DIGITAL QUICK RESPONSE (QR) CODE
        </div>

        <div style={{ padding: "10px", display: "flex", justifyContent: "center" }}>
          <img
            src={pkn1}
            alt=""
            style={{
              margin: "auto",
              width: "70%",
            }}
          />
        </div>
        <div style={{ padding: "10px", display: "flex", justifyContent: "center" }}>
          <table style={{ marginTop: "10px" }}>
            <tbody>
              <tr>
                <td style={{ verticalAlign: "top", fontWeight: "bold" }}>BARIS PERTAMA</td>
                <td style={{ width: "20px" }}>:</td>
                <td>KPR BERSUBSIDI (HURUF IMPACT UKURAN 66)</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top", fontWeight: "bold" }}>BARIS KEDUA</td>
                <td style={{ width: "20px" }}>:</td>
                <td>PEMERINTAH REPUBLIK INDONESIA (HURUF IMPACT UKURAN 40)</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top", fontWeight: "bold" }}>BARIS KETIGA</td>
                <td style={{ width: "20px" }}>:</td>
                <td>LOGO BANK PENYALUR DANA FLPP</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top", fontWeight: "bold" }}>UKURAN</td>
                <td style={{ width: "20px" }}>:</td>
                <td>21 CM X 15 CM</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top", fontWeight: "bold" }}>WARNA DASAR</td>
                <td style={{ width: "20px" }}>:</td>
                <td>baris pertama dan kedua menggunakan warna R(91) G(178) B(72)</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style={{ padding: "10px", display: "flex", justifyContent: "center" }}>
          <img
            src={pkn2}
            alt=""
            style={{
              margin: "auto",
              width: "40%",
            }}
          />
        </div>
        <div style={{ padding: "10px", display: "flex", justifyContent: "center" }}>
          {" "}
          <p>
            Keterangan : <br />
            Stiker/Plat KPR Bersubsidi BTN dipasang di bagian depan rumah penerima bantuan
          </p>
        </div>
      </div>
    </div>
  );
};
